module.exports = __webpack_public_path__ + "99e04fb87e30bc07e4c18256ff5e902c.png";